import React, { useState } from "react";
import { api } from "../../lib/apiClient";
import { Switch } from "../ui/switch";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

const stamp = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");

// Green approve slider shown left of Print on quotes whose labour type needs sign-off.
export function ApprovalSlider({ quote, canApprove, onChange }) {
  const [busy, setBusy] = useState(false);
  const approved = !!quote.approved;

  const toggle = async (on) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/quotes/${quote.id}/approve`, { approved: on });
      onChange(data);
      toast.success(on ? "Quote approved — print & export unlocked." : "Approval removed — print & export locked.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update approval");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative" data-testid="approval-slider-wrap">
      <label
        className={`h-9 px-4 rounded-full border-2 inline-flex items-center gap-2 text-xs uppercase tracking-wider font-semibold transition-colors ${
          approved ? "border-emerald-600 bg-emerald-600 text-white" : "border-emerald-500 bg-emerald-50 text-emerald-800"
        } ${canApprove ? "cursor-pointer" : "cursor-not-allowed opacity-80"}`}
        title={canApprove ? "" : "You're not set up to approve quotes — ask an approver"}
      >
        <ShieldCheck size={14} />
        {approved ? "Approved" : "Approve"}
        <Switch
          checked={approved}
          disabled={!canApprove || busy}
          onCheckedChange={toggle}
          className="data-[state=checked]:bg-white data-[state=unchecked]:bg-emerald-300 [&>span]:data-[state=checked]:bg-emerald-600"
          data-testid="approval-switch"
        />
      </label>
      {approved && quote.approved_by && (
        <div className="absolute left-0 right-0 top-full mt-1 text-center text-[9px] uppercase tracking-wider text-emerald-700 font-semibold whitespace-nowrap" data-testid="approval-stamp">
          {quote.approved_by} · {stamp(quote.approved_at)}
        </div>
      )}
    </div>
  );
}
